import './surveySectionItem.scss';
import { Image } from "@umu/umu-design";
import { getData } from '@umu/umu-util';
import { MediaType, ESectionValid, ESurveySectionType } from '@umu/umu-types';
import { lang, commonLang } from '@umu/ukit-lang';
import React, { Component, useMemo } from 'react';
import { SECTION_COLOR_SCHEME_TOTAL } from '../../../../@utils/index';
import SectionMediaPlayer from '../../../../baseComponents/mediaPlayer';
import SectionParagraph from '../../../@sectionParagraph/sectionParagraph';
import { preSignedUrl, appendWidth, CONTENT_TYPE, ELEMENT_TYPE } from '@umu/umu-image-handle';
import {
    ISurveySectionInfo,
    ISectionResult,
    IPollResourceArrInfo,
    ELEMENT_TYPE as ElementType,
    IAssessmentDimension,
} from '@umu/umu-types';
import { SectionRadiobox as SectionRadioboxList } from '../../@surveySectionTypes/@surveySectionRadio/surveySectionRadio';
import { SurveySectionCheckbox as SectionCheckboxList } from '../../@surveySectionTypes/@surveySectionCheckbox/surveySectionCheckbox';
import { SurveySectionText as SectionTextarea } from '../../@surveySectionTypes/@surveySectionText/surveySectionText';
import { SurveySectionNumber as SectionNumber } from '../../@surveySectionTypes/@surveySectionNumber/surveySectionNumber';

export interface IProps {
    key: number;
    isShowDescImg?: boolean; // 是否要展示描述图片
    step?: number; // 兼容数值型问题
    showInput?: boolean; // 兼容数值型问题
    isShowDimensionsLabel?: boolean; // 是否展示维度标签
    elementId?: string;
    elementType?: ElementType;
    sectionInfo: ISurveySectionInfo;
    isDisabled?: boolean;
    onValueUpdate(value: ISectionResult, isValid: ESectionValid): void;
}
export interface IDimensionLabelListProps {
    list: IAssessmentDimension[];
    isShow: boolean;
    topicIndex?: number;
}
export const DimensionLabelList = (props: IDimensionLabelListProps) => {
    const { isShow, list, topicIndex = 0 } = props;
    const renderDimension = useMemo(() => {
        return list && list.length > 0
            ? list.map((dimension: IAssessmentDimension, index: number) => {
                  return (
                      <span
                          key={`dimension-${topicIndex}-${index}`}
                          className={`dimension-span dimension-${(dimension.index % SECTION_COLOR_SCHEME_TOTAL) + 1}`}
                      >
                          {dimension.dimension}
                      </span>
                  );
              })
            : null;
    }, [list]);
    return isShow ? <div className="dimension-label-list">{renderDimension}</div> : null;
};
export class SurveySectionItem extends Component<IProps> {
    mediaContainer:HTMLDivElement|null=null;
    player:any=null;
    constructor(props: IProps) {
        super(props);
        this.player=null;
    }

    componentDidMount(){
        this.initialMediaPlayer();
    }

    public initialMediaPlayer() {

        const { elementId, elementType,sectionInfo } = this.props;
        const{media_type,resource_arr=[]}=sectionInfo.extend;
        if(media_type!==MediaType.VIDEO && media_type !== MediaType.AUDIO){
            return;
        }
        const resourceInfo = resource_arr[0];

        const url = getData(resourceInfo, 'resource_data', 'url') as string;
        const preUrl = preSignedUrl(url, `${elementId}`, CONTENT_TYPE.ELEMENT, elementType as any as ELEMENT_TYPE);

        const playerOptions = {
            type:media_type,
            options:{
                parent: this.mediaContainer,
                url: preUrl,
            }
        };

        this.player = new SectionMediaPlayer(playerOptions);
    }
    public renderSectionHeader() {
        const { sectionInfo, isShowDimensionsLabel = false, isShowDescImg = false } = this.props;
        const { type, sectionIndex, title, schemeIndex = 1 } = sectionInfo;
        if (type === ESurveySectionType.PARAGRAPH) {
            return null;
        }

        return (
            <div className={`section-item-header scheme-${schemeIndex}`}>
                <DimensionLabelList
                    isShow={isShowDimensionsLabel}
                    list={sectionInfo.dimensions || []}
                    topicIndex={sectionIndex}
                ></DimensionLabelList>
                <div className="section-item-header-title">
                    {sectionIndex ? <span className={`section-num`}>Q{sectionIndex}. </span> : null}
                    <span className="section-title">{title}</span>
                    <span className="section-title-desc">{this.getTitleRange()}</span>
                </div>
                {isShowDescImg && sectionInfo.pic_url && this.renderSectionDescImg(sectionInfo.pic_url)}
                {this.renderSectionHeaderResource()}
            </div>
        );
    }
    //题干描述图片展示
    public renderSectionDescImg(urls?: string) {
        const thumbUrl = appendWidth(urls || '');
        const resourceData = {
            thumb_url: thumbUrl,
            url: thumbUrl
        };

        return urls ? (
            <div className="section-header-img">
                <div className="img">
                    <Image src={resourceData.url} previewControl={true} />
                </div>
            </div>
        ) : null;
    }
    /**
     * 题目下的音视频、图片
     */
    public renderSectionHeaderResource() {
        const { media_type } = this.props.sectionInfo.extend;

        const { resource_arr = [] } = this.props.sectionInfo.extend;
        const resourceInfo = resource_arr[0];
        if (!resourceInfo) {
            return null;
        }

        if (media_type === MediaType.VIDEO || media_type === MediaType.AUDIO) {
            return this.renderSectionHeaderMedia();
        }
        return this.renderSectionHeaderImage(resourceInfo);
    }

    public renderSectionHeaderVideo(resource: IPollResourceArrInfo) {
        const { elementId, elementType } = this.props;
        const url = getData(resource, 'resource_data', 'url') as string;
        const preUrl = preSignedUrl(url, `${elementId}`, CONTENT_TYPE.ELEMENT, elementType as any as ELEMENT_TYPE);
        return <video width="100%" src={preUrl} controls={true}></video>;
    }

    public renderSectionHeaderMedia() {
        return (
            <div className="audio-section">
               <div
                ref={(ref) => {
                    this.mediaContainer = ref;
                }}
               ></div>
            </div>
        );
    }

    public renderSectionHeaderImage(resource: IPollResourceArrInfo) {
        const url = resource.resource_data.url;
        const thumbUrl = appendWidth(url);
        const resourceData = Object.assign({}, resource.resource_data, {
            thumb_url: thumbUrl,
        });

        return (
            <div className="section-header-img">
                <div className="img">
                    <Image src={resourceData.url} previewControl={true} />
                </div>
            </div>
        );
    }

    public getTitleRange = () => {
        const { sectionInfo } = this.props;
        const { type, list, extend } = sectionInfo;
        const { setup } = extend;

        const retTitle = [];
        let ret = '';

        if (type === ESurveySectionType.CHECKBOX) {
            const min = Number(setup.limit_options_min);
            const max = Number(setup.limit_options_max);
            const total = (list || []).length;
            ret = lang('多选');
            if (min && max) {
                if (min === max) {
                    ret = lang('多选，{$0{0=个,1=个}}选项', min);
                } else if (min === 1) {
                    ret = lang('多选，至多{$0{0=个,1=个}}选项', max);
                } else if (max === total) {
                    ret = lang('多选，至少{$0{0=个,1=个}}选项', min);
                } else {
                    ret = lang('多选，{$0}-{$1}个选项', min, max);
                }
            }
            retTitle.push(ret);
        } else if (type === ESurveySectionType.RADIO) {
            ret = lang('单选');
            retTitle.push(ret);
        }

        if (setup.require === '0') {
            ret = lang('选填');
            retTitle.push(ret);
        }

        if (retTitle.length) {
            ret = ` ${commonLang('（')}` + retTitle.join(commonLang('，')) + commonLang('）');
        }

        return ret;
    };

    public renderSectionBody() {
        const { sectionInfo, isDisabled, onValueUpdate, step, showInput } = this.props;
        const { type } = sectionInfo;

        const questionMap: any = {
            [ESurveySectionType.PARAGRAPH]: SectionParagraph,
            [ESurveySectionType.RADIO]: SectionRadioboxList,
            [ESurveySectionType.CHECKBOX]: SectionCheckboxList,
            [ESurveySectionType.TEXTAREA]: SectionTextarea,
            [ESurveySectionType.NUMBER]: SectionNumber,
        };

        const questionSection = questionMap[type];
        if (!questionSection) {
            return null;
        }

        return React.createElement(questionSection, {
            step,
            showInput,
            sectionInfo,
            isDisabled,
            onValueUpdate,
        });
    }

    public render() {
        return (
            <div className="section-item">
                {this.renderSectionHeader()}
                {this.renderSectionBody()}
            </div>
        );
    }
}
